/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Create_PermissionInputs */

const en_admin_permissions_create_permission = /** @type {(inputs: Admin_Permissions_Create_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Permission`)
};

const zh_admin_permissions_create_permission = /** @type {(inputs: Admin_Permissions_Create_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建权限`)
};

/**
* | output |
* | --- |
* | "Create Permission" |
*
* @param {Admin_Permissions_Create_PermissionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_create_permission = /** @type {((inputs?: Admin_Permissions_Create_PermissionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Create_PermissionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_create_permission(inputs)
	return zh_admin_permissions_create_permission(inputs)
});
export { admin_permissions_create_permission as "admin.permissions.create_permission" }